import { render, staticRenderFns } from "./user-item.vue?vue&type=template&id=119124af&scoped=true&"
import script from "./user-item.vue?vue&type=script&lang=js&"
export * from "./user-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119124af",
  null
  
)

export default component.exports